module.exports = __webpack_public_path__ + "img/50n.5c559c28.png";